<template>
  <button class="lang-toggle" @click="toggle" :title="$i18n.locale === 'zh' ? 'Switch to English' : '切换到中文'">
    <span class="lang-current">{{ $i18n.locale === 'zh' ? 'EN' : '中' }}</span>
  </button>
</template>

<script>
export default {
  name: 'LanguageToggle',
  inject: ['i18n'],
  methods: {
    toggle() {
      this.$i18n.toggle()
      this.$forceUpdate && this.$forceUpdate()
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.lang-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 36px;
  padding: 0 12px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-color);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.lang-toggle:hover {
  border-color: var(--accent-primary);
}

.lang-current {
  font-family: var(--font-mono);
  font-size: 12px;
  font-weight: 700;
  color: var(--accent-primary);
  letter-spacing: 1px;
}
</style>
